// extracted by mini-css-extract-plugin
module.exports = {"groupSelect":"groupSelect__XnJwL","groupSelected":"groupSelected__3FOHY","removeButton":"removeButton__Pxs3M","mapCont":"mapCont__1t9PD"};